
import { defineComponent } from 'vue';
import { abreWhatsApp } from '@/uteis/contato';
import { rolarPara } from '@/uteis/navegacao';
import { conteudoSite, urlDaImagem, Slide } from '@/uteis/conteudo';

const INTERVALO_MS = 3500;

export default defineComponent({
    name: 'HeroPrincipal',
    props: {
        TextoWhatsApp: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            indice: 0,
            temporizador: 0,
            conteudo: conteudoSite
        };
    },
    computed: {
        slides(): Slide[] {
            return this.conteudo.hero.slides;
        },
        slideAtual(): Slide {
            return this.slides[this.indice % this.slides.length] ?? this.slides[0];
        }
    },
    mounted() {
        this.retomar();
    },
    beforeUnmount() {
        this.pausar();
    },
    methods: {
        abrirWhatsApp() {
            abreWhatsApp(this.TextoWhatsApp, 'Orçamento (topo)');
        },
        rolarPara,
        urlDaImagem,
        avancar() {
            this.indice = (this.indice + 1) % Math.max(this.slides.length, 1);
        },
        irParaSlide(i: number) {
            this.indice = i;
            this.pausar();
            this.retomar();
        },
        pausar() {
            if (this.temporizador) {
                window.clearInterval(this.temporizador);
                this.temporizador = 0;
            }
        },
        retomar() {
            if (!this.temporizador) {
                this.temporizador = window.setInterval(this.avancar, INTERVALO_MS);
            }
        }
    }
});
